import type { StateCreator } from 'zustand';
import type { AttendancePolicy } from '@abs/shared-types';
import { generateId } from '@/utils/id';

export interface PolicySlice {
  policies: AttendancePolicy[];

  addPolicy: (policy: Omit<AttendancePolicy, 'id'>) => string;
  updatePolicy: (id: string, updates: Partial<Omit<AttendancePolicy, 'id'>>) => void;
  deletePolicy: (id: string) => void;
  duplicatePolicy: (id: string) => string | null;
}

export const createPolicySlice: StateCreator<PolicySlice> = (set, get) => ({
  policies: [],

  addPolicy: (policyData) => {
    const id = generateId();
    const policy: AttendancePolicy = { ...policyData, id };
    set((state) => ({ policies: [...state.policies, policy] }));
    return id;
  },

  updatePolicy: (id, updates) => {
    set((state) => ({
      policies: state.policies.map((p) =>
        p.id === id ? { ...p, ...updates } : p,
      ),
    }));
  },

  deletePolicy: (id) => {
    set((state) => ({
      policies: state.policies.filter((p) => p.id !== id),
    }));
  },

  duplicatePolicy: (id) => {
    const policy = get().policies.find((p) => p.id === id);
    if (!policy) return null;

    const newId = generateId();
    const clone: AttendancePolicy = {
      ...structuredClone(policy),
      id: newId,
      name: `${policy.name} (Copy)`,
    };
    set((state) => ({ policies: [...state.policies, clone] }));
    return newId;
  },
});
